import * as React from 'react';

interface IProps extends React.HTMLAttributes<HTMLImageElement> {
    /** Employee Id as string or number to fetch */
    employeeId?: string | number;
    /** Username of employee. Will be Parsed to initials  */
    value?: string;
    /** Sets both width and height of image element */
    size?: number | string;
}

const EmployeeBadge: React.FC<IProps> = (props: IProps) => {
    //r-18-lint-dj
    //eslint-disable-next-line
    // const { className, employeeId } = props;
    // const hasFetched: any = React.useRef(false);
    // const cancelToken: any = React.useRef(axios.CancelToken.source());
    //r-18-lint-dj
    //eslint-disable-next-line
    // const [loadingImage, setLoadingImage] = React.useState(false);
    // const [profileImage, setProfileImage] = React.useState(Swoosh);

    // const parseValue = (value: string): string => {
    //     if (!value) {
    //         console.error("A Value must be provided. Value Provided: ", value);
    //         return "ERR!";
    //     }
    //     let parsedValue: string = value.toUpperCase();
    //     let splitValue: Array<string> = parsedValue.split(" ");
    //     if (splitValue.length === 1) {
    //         parsedValue = splitValue[0].substring(0, 2);
    //     }
    //     if (splitValue.length === 2) {
    //         parsedValue = splitValue[0].charAt(0) + splitValue[1].charAt(0);
    //     } else if (splitValue.length === 3) {
    //         parsedValue = splitValue[0].charAt(0) + splitValue[1].charAt(0) + splitValue[2].charAt(0);
    //     } else {
    //         parsedValue = splitValue[0].charAt(0) + splitValue[1].charAt(0) + splitValue[splitValue.length - 1].charAt(0);
    //     }
    //     return parsedValue;
    // }

    // const getBadgePic = () => {
    //     setLoadingImage(true);
    //     const config: any = AxiosConfig.configValue();
    //     axios.get(process.env.REACT_APP_API_URL + "/api/user/getEmployeeBadgePic/" + employeeId, { ...config, cancelToken: cancelToken.current.token })
    //         .then((res) => {
    //             if (res.data.badgePic[0]) {
    //                 const imageUrl: string = res.data.badgePic[0].imageFullUrl + `?t=${Date.now()}`;
    //                 setProfileImage(imageUrl);
    //                 sessionStorage.setItem(`badge_${employeeId}`, imageUrl);
    //             } else {
    //                 setProfileImage(Swoosh);
    //                 sessionStorage.setItem(`badge_${employeeId}`, "DEFAULT");
    //             }
    //         })
    //         .catch((error: any) => {
    //             //console.log("error", error);
    //             AxiosConfig.handleError(error);
    //         })
    //         .finally(() => {
    //             setLoadingImage(false);
    //             hasFetched.current = true;
    //         })
    //     return () => {
    //         cancelToken.current.cancel();
    //     }
    // }

    // React.useEffect(() => {
    //     let stored: any = sessionStorage.getItem(`badge_${employeeId}`)
    //     if (stored) {
    //         setProfileImage(stored);
    //         hasFetched.current = true;
    //     } else {
    //         if (employeeId) { //? If employeeId is passed, then get the profile image
    //             //console.log("Employee Badge: ", employeeId, hasFetched.current, profileImage);
    //             !hasFetched.current && getBadgePic();
    //         } else if (props.value) { //? If value is passed, then parse the value and get the profile image
    //             setProfileImage(parseValue(props.value));
    //             hasFetched.current = true;
    //         }
    //     }
    //     //r-18-lint-dj
    //     //eslint-disable-next-line
    // }, [employeeId]);

    return (
        // <img
        //     id="r-eop-profile-pic-collapsed"
        //     //? Pass all other props here as well
        //     style={{ minHeight: 50, minWidth: 50, maxHeight: 100, maxWidth: 100, borderRadius: "50%", width: props.size, height: props.size, ...props.style }}
        //     className={`shadow ${props.className}`}
        //     src={profileImage}
        //     alt="Employee Badge"
        // />
        <></>
    )
}

EmployeeBadge.defaultProps = {
    className: "",
    style: {},
    size: 50,
}

export default EmployeeBadge;